export const API_URL = "https://api.spoonacular.com/recipes/complexSearch";
export const API_KEY = "apiKey=ae41aac1a8ad4e9787147515e9a3ff5e";
